import React from 'react';
import AFCRulesInfographic from './components/AFCRulesInfographic';

function App() {
  return (
    <div className="App">
      <AFCRulesInfographic />
    </div>
  );
}

export default App;
